var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.faqLoaded && _vm.faqs.length > 0)?_c('div',_vm._l((_vm.faqs),function(faq,index){return _c('div',{key:index},[_c('FaqSingle',{attrs:{"faq":faq}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }